// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__Sq0d7","Image__caption":"Image_Image__caption__resVg"};